import ky, {Options, ResponsePromise} from "ky";
import {IObservableArray} from "mobx";
const AntiForgeryTokenName = "$AntiforgeryToken";
// @ts-ignore
import {Cash} from "cash-dom/dist/cash";
import {serializeError} from "serialize-error";
import * as Sentry from "@sentry/browser";
import {Severity} from "@sentry/browser";




const EXT_CONTEXT = "ExtContext";
const USE_SENTRY = process.env.SENTRY === "true";

class GlobalSettings{
    sentryDsn:string;
    redirectPath:string;
}
const gSettings = new GlobalSettings();
let w = (window as any);
if (w.gExternalToken)
{
    gSettings.sentryDsn = w.gSentryDsn;
    gSettings.redirectPath = w.gRedirectPath;
}

export class ExtError extends Error{

    constructor(e?:Error) {
        if (e) {
            super(e.message);
            this.name = e.name;
            this.stack = e.stack;
        } else{
            super("");
        }
    }
    data:Record<string, unknown>;
    alreadySent:boolean;
}

interface IHandleErrorOpts {
    runAfterErrorHandle?: boolean;
    message?: string;
    extra?: any;
}

interface IInitErrorHandlersOpts {
    afterErrorHandle:()=>void;
}

interface IExtErrorContext extends Record<string, unknown> {
    runAfterErrorHandle?: boolean;
    extra?: any;
}


const kyApi = ky.extend({
    hooks: {
        beforeRequest: [
            request => {
                const value = (<HTMLInputElement[]><any>document.getElementsByName(AntiForgeryTokenName))[0].value;
                request.headers.set(AntiForgeryTokenName, value);

                let externalToken = (window as any).gExternalToken;
                if (externalToken) {
                    request.headers.set("ExternalToken", externalToken);
                }

            }
        ]
    }
});

export interface IExtArray<T> extends Array<T>, IObservableArray<T> {
    skip(i: number): T[]
    take(i: number): T[]
}

export interface IAjaxResult<T> {
    data: T;
    /**
     * @deprecated Use Code instead of Ok
     */
    ok: boolean;
    code:AjaxResultCode;
    /**
     * @deprecated Use Code instead of Ok
     */
    message: string;
    promise: ResponsePromise
}
export enum AjaxResultCode{
    Fail = 0,
    Success = 1,

    NotAuthorized = 401,
    NotFound = 404,
    ServerError = 500
}

export function post<T>(url: string, model?: any): Promise<IAjaxResult<T>> {

    let options: Options = {
        timeout: 30 * 60 * 1000,//30 min
        retry: 1,
    };
    if (model) {
        if (model instanceof FormData) {
            //заглушка, чтобы правильно формировало хедеры
            let blob = new Blob(["text"], {type: "text/plain"});
            model.append("fileForStoreData", blob);
            options.body = model;
        } else {
            options.json = model;
        }
    }

    const responsePromise = kyApi.post(url, options);

    //try catch
    return responsePromise.json<IAjaxResult<T>>()
        .then(r => {
            r.promise = responsePromise;
            return r;
        })
        .catch(async (e) => {
            const data = {
                url: url,
                model: model
            }
            if(e.response.status === 401 || e.response.status === 403){
                window.location.href = gSettings.redirectPath;
            }
            else if (url != "/error/SendError/") {
                handleError(e, 
                    {
                        extra:data
                    });
            }
            return e;
        });
}

function sendError(err:Error|ErrorEvent){
    let data;

    if (err instanceof Error){
        data = {
            serializeError: JSON.stringify(serializeError(err))
        };
    }

    if(err instanceof ErrorEvent){
        const { message, filename, lineno, error } = err;
        data = {
            serializeError: JSON.stringify(serializeError(error)),
            message:message,
            fileNameJs:filename,
            lineNumberInJsFile:lineno.toString(),
            url: window.location.href.toString()
        }
    }

    post<string>("/error/SendError/", data).catch(e => {
        //nothing happens, if error in SendError - just skip it
    });
}

export function handleError(e:Error, opts?: IHandleErrorOpts) {

    const err = new ExtError(e);
    let context: IExtErrorContext = {};
    if(typeof opts !== "undefined"){
        if (opts.extra) {
            context.extra = opts.extra;
        }
        if (opts.runAfterErrorHandle === true) {
            context.runAfterErrorHandle = opts.runAfterErrorHandle;
        } else {
            context.runAfterErrorHandle = false;
        }
    }

    if (USE_SENTRY) {
        Sentry.captureException(e, scope => scope
            .setLevel(Severity.Error)
            .setContext(EXT_CONTEXT, context)
        );

    } else{
        sendError(e);
    }
    err.alreadySent = true;
}

export function initErrorHandlers(opts:IInitErrorHandlersOpts){

    if (USE_SENTRY) {
        Sentry.init({
            dsn: gSettings.sentryDsn,
            beforeSend: (event: Sentry.Event, hint?: Sentry.EventHint) => {
                if (event.contexts) {
                    let context = event.contexts[EXT_CONTEXT] as IExtErrorContext;
                    if (context.runAfterErrorHandle) {
                        if (opts.afterErrorHandle) {
                            opts.afterErrorHandle();
                        }
                    }
                } else {
                    if (opts.afterErrorHandle) {
                        opts.afterErrorHandle();
                    }
                }
                return event;
            }
        });
        Sentry.configureScope(function(scope) {
            scope.setLevel(Sentry.Severity.Fatal);
        });

    } else {

        window.addEventListener("error", e =>{

            sendError(e);
            if (opts.afterErrorHandle) {
                opts.afterErrorHandle();
            }
        });
    }
}